import { ApiOrderTransaction } from '@api/interfaces/ApiOrderTransaction';
import { OrderTransactionSubtype } from '@shared/enums';
import { TFunction } from 'i18next';

export function getTransactionTypeLabel (
  order: ApiOrderTransaction,
  t: TFunction,
): string {
  if (order.orderSubtype === OrderTransactionSubtype.SCALE_TICKET) {
    return t(($) => $.orders.scaleTicket);
  } else if (order.orderSubtype === OrderTransactionSubtype.SETTLEMENT) {
    return t(($) => $.orders.settlement);
  }
  return t(($) => $.orders.order);
}

export function isOrderAssociatedWithBooking (
  order: ApiOrderTransaction,
): boolean {
  return order.products?.some((product) => !!product.linkedBookingId) ?? false;
}
